import React, { useState } from 'react';
import { Modal, Input, Radio, Select} from 'antd';
import { toOptionsList } from '../../utilities/utilFunctions';
import { useEffect } from 'react';
function BlupsFilteringPopup({ label, popUpTitle, functions, name, options, selectedRows, data}) {
    const [visible, setVisible] = useState(false);
    const [selectedTraits, setSelectedTraits] = useState([]);
    const [useVarietyList, setUseVarietyList] = useState(false);
    const [varietyText, setVarietyText] = useState('')
    // const [useTraitList, setUseTraitList] = useState(false);
    const [traitOptions, setTraitOptions] = useState([])
    const showModal = async () => {  
        if(data[0]) {
            const header = Object.keys(data[0]);
            const traits = header.slice(1);
            const options = toOptionsList(traits);
            setTraitOptions(options);
        };
        
        setVisible(true);
    };

    const handleOk = () => {
        let varieties = [];
        if(useVarietyList) {
            varieties = varietyText.split('\n');
            if(varieties.length === 1 && varieties[0] === '') {
                varieties = [];
            }
        }  
        else {
            varieties = selectedRows.map(row => row.NAME)
        }
        functions.createFilteredOutput(varieties, selectedTraits);
        setSelectedTraits([]);
        setVarietyText('');
        setVisible(false);      
    };

    const handleCancel = () => {
        setSelectedTraits([]);
        setVarietyText('');
        setVisible(false);
    };

    const onVarietyInputTypeChange = (e) => {
        if(e.target.value === 'list') {
            setUseVarietyList(true);
        }
        else {
            setUseVarietyList(false)
        }
    }
    // const onTraitInputTypeChange = (e) => {
    //     if(e.target.value === 'list') {
    //         setUseTraitList(true);
    //     }
    //     else {
    //         setUseTraitList(false);
    //     }
    // }
    const handleSelectedTraitsChange = (selected) => {
        setSelectedTraits(selected);
    }
    const handleVarietyText = (e) => {
        setVarietyText(e.target.value);
    }
    
    const varietyList = selectedRows.map(row=> <li>{row.NAME}</li>)
    return (
        <div>
            <button className="btn btn-success" onClick={showModal}>
                {label}
            </button>
            <Modal
                // title={popUpTitle}
                open={visible}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <br/>
                <h6>Filter by Traits</h6>
                {/* <Radio.Group onChange={onTraitInputTypeChange} defaultValue="rows">
                    <Radio.Button value="rows">Select Traits</Radio.Button>
                    <Radio.Button value="list">Use Trait List</Radio.Button>
                </Radio.Group> */}
                {
                    // (!useTraitList &&
                        <Select
                        style={{width : '100%'}}
                        mode={'multiple'}
                        options={traitOptions}
                        placeholder={'Traits'}
                        value={selectedTraits}
                        onChange={handleSelectedTraitsChange}
                        ></Select>
                        
                        // <Checkbox.Group
                        //     value={selectedTraits}
                        //     onChange={onTraitCheck}
                        // >
                        //     <ul>{traitList}</ul>
                        // </Checkbox.Group>
                        
                    // ) ||
                    // (useTraitList &&
                    //     <Input.TextArea
                    //     placeholder={'Enter one trait per line...'}></Input.TextArea>
                    // )
                }
                * Leave empty to include all traits
                <br />
                <br />
                <h6>Filter by Variety</h6>
                <Radio.Group onChange={onVarietyInputTypeChange} defaultValue="rows">
                    <Radio.Button value="rows">Use Selected Rows</Radio.Button>
                    <Radio.Button value="list">Use Variety List</Radio.Button>
                </Radio.Group>
                
                <br />
                <br />
                {
                    (!useVarietyList &&
                        <div>
                            Using Selected Rows: <br />
                            Select a row in the BLUPs table by clicking the checkbox to its left<br />
                            The filtered result will include records with values of 'NAME' that match those in the selected rows. <br />
                            If no rows are selected, all varieties will be included in the filtered result.
                        </div>
                    ) ||
                    (useVarietyList &&
                        <Input.TextArea
                        placeholder={'Enter one variety per line...'}
                        value={varietyText}
                        onChange={handleVarietyText}></Input.TextArea>
                    )
                }
                <br />            
                {/* <br />
                <ul>{varietyList}</ul>
                <br /> */}
            </Modal>
        </div>
    );
}

export default BlupsFilteringPopup;
